<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import initJsSdk from "@/util/initJsSdk";
export default {
  mounted() {
    try {
      initJsSdk();
    } catch (e) {
      console.log("initJsSdk-初始化失败", e);
    }
  },
  destroyed() {
    localStorage.removeItem("gallery_scroll");
  },
};
</script>
<style lang="less"></style>
